import appEventBus, { API_REMOVE_ACTIVE_AD_GROUP_HEADER, API_ADD_ACTIVE_AD_GROUP_HEADER } from 'config/appEventBus';
import {
  associatePerformanceService,
  globalOrdersSearchService,
  accountAssociateHierarchyService,
  globalOrdersSearchV2Service,
} from 'config/api';
import {
  MAX_FILES_FOR_SMS_SHARING,
  DEFAULT_ACCOUNT_ASSOCIATE_WIDGET_SETTING,
  ASSOCIATE_NOT_FOUND_EXCEPTION,
} from 'constants/index';
import isEmpty from 'lodash/isEmpty';
import actionTypes from './actionTypes';

export const setUser = (cognitoUserData) => {
  return {
    type: actionTypes.SET_USER,
    payload: cognitoUserData,
  };
};

export const setStoreNumber = (storeNumber = '') => {
  return {
    type: actionTypes.SET_STORE_NUMBER,
    payload: storeNumber,
  };
};

export const setActiveUserADGroup = (groupName) => {
  appEventBus.emit(API_ADD_ACTIVE_AD_GROUP_HEADER, groupName);

  return {
    type: actionTypes.SET_ACTIVE_USER_AD_GROUP,
    payload: groupName,
  };
};

export const resetActiveUserADGroup = () => {
  appEventBus.emit(API_REMOVE_ACTIVE_AD_GROUP_HEADER);

  return {
    type: actionTypes.RESET_ACTIVE_USER_AD_GROUP,
  };
};

export const signOut = () => {
  return {
    type: actionTypes.SIGN_OUT,
  };
};

export const hideGlobalNavigation = () => ({
  type: actionTypes.HIDE_GLOBAL_NAVIGATION,
});

export const showGlobalNavigation = () => ({
  type: actionTypes.SHOW_GLOBAL_NAVIGATION,
});

export const addNotification = (notification) => ({
  type: actionTypes.ADD_NOTIFICATION,
  payload: notification,
});

export const clearNotification = (id) => ({
  type: actionTypes.CLEAR_NOTIFICATION,
  payload: { id },
});

export const checkAttachmentsLimit =
  (attachments = [], isFileAttachments, isEmail) =>
  async (dispatch, getState) => {
    if (isFileAttachments) {
      const stateFileAttachmentsCount = getState().clientingModule?.conversation?.attachments?.filter(
        ({ item }) => item instanceof window.File,
      ).length;
      const totalFileAttachmentsLength = attachments?.length + stateFileAttachmentsCount;

      if (!isEmail && totalFileAttachmentsLength > MAX_FILES_FOR_SMS_SHARING) {
        dispatch(
          addNotification({
            id: `error-${Date.now()}`,
            message: '10 file attachments limit exceeded',
            type: 'error',
          }),
        );

        return true;
      }
    }
    return false;
  };

export const getMasterDivisionsList = () => async (dispatch) => {
  dispatch({
    type: actionTypes.DIVISIONS_LIST_LOADING,
  });

  try {
    const url = '/v1/configuration/divisions/list';
    const res = await associatePerformanceService.get(url);

    dispatch({ type: actionTypes.DIVISIONS_LIST_SUCCESS, payload: res.data });
  } catch (error) {
    dispatch({ type: actionTypes.DIVISIONS_LIST_ERROR, payload: error });
  }
};

export const getOrdersAccordingToAdvancedParams =
  (requestBody, isMAOInventoryEnabled = false) =>
  async (dispatch) => {
    dispatch({
      type: actionTypes.GET_ORDERS_ACCORDING_TO_ADVANCED_PARAMS_LOADING,
    });
    try {
      const { data } = await (isMAOInventoryEnabled ? globalOrdersSearchV2Service : globalOrdersSearchService).post(
        '',
        requestBody,
      );

      dispatch({
        type: actionTypes.GET_ORDERS_ACCORDING_TO_ADVANCED_PARAMS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: actionTypes.GET_ORDERS_ACCORDING_TO_ADVANCED_PARAMS_ERROR,
      });
    }
  };

export const restoreOrdersAccordingToAdvancedParams = (ordersState) => ({
  type: actionTypes.RESTORE_ORDERS_ACCORDING_TO_ADVANCED_PARAMS,
  payload: ordersState,
});

export const resetOrdersAccordingToAdvancedParams = () => ({
  type: actionTypes.RESET_ORDERS_ACCORDING_TO_ADVANCED_PARAMS,
});

export const getAssociateWidgetInformation = (associatePin) => async (dispatch) => {
  dispatch({
    type: actionTypes.ACCOUNT_GET_ASSOCIATE_WIDGET_INFORMATION_LOADING,
  });

  try {
    const url = `associate/widget/${associatePin}`;
    const res = await accountAssociateHierarchyService.get(url);

    dispatch({
      type: actionTypes.ACCOUNT_GET_ASSOCIATE_WIDGET_INFORMATION_SUCCESS,
      payload: {
        associatePin,
        associateWidgetInfo: isEmpty(res.data) ? DEFAULT_ACCOUNT_ASSOCIATE_WIDGET_SETTING : res.data,
      },
    });
  } catch (error) {
    if (error.response?.data?.message?.startsWith(ASSOCIATE_NOT_FOUND_EXCEPTION)) {
      dispatch({
        type: actionTypes.ACCOUNT_GET_ASSOCIATE_WIDGET_INFORMATION_SUCCESS,
        payload: {
          associatePin,
          associateWidgetInfo: DEFAULT_ACCOUNT_ASSOCIATE_WIDGET_SETTING,
        },
      });
    } else {
      dispatch({ type: actionTypes.ACCOUNT_GET_ASSOCIATE_WIDGET_INFORMATION_ERROR, payload: error });
    }
  }
};

export const updateAssociateWidgetInformation = (requestPayload) => async (dispatch) => {
  dispatch({
    type: actionTypes.ACCOUNT_UPDATE_ASSOCIATE_WIDGET_INFORMATION_LOADING,
  });

  try {
    const url = 'associate/widget';
    const res = await accountAssociateHierarchyService.post(url, requestPayload);

    dispatch({
      type: actionTypes.ACCOUNT_UPDATE_ASSOCIATE_WIDGET_INFORMATION_SUCCESS,
      payload: {
        response: res.data,
        requestPayload,
      },
    });
  } catch (error) {
    dispatch({ type: actionTypes.ACCOUNT_UPDATE_ASSOCIATE_WIDGET_INFORMATION_ERROR, payload: error });
  }
};
